var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "web-row-header__chevron",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2943 3.29156C9.90189 3.6803 9.90189 4.30965 10.2943 4.69839L17.5371 11.8708C17.6154 11.9483 17.6154 12.0746 17.5371 12.1521L10.3214 19.3016C9.92899 19.6904 9.90189 20.3197 10.2933 20.7084C10.6848 21.0972 11.3211 21.0972 11.7136 20.7084L19.4954 13.028C20.1769 12.353 20.1568 11.655 19.5034 11.0078L11.7136 3.29156C11.3221 2.90281 10.6858 2.90281 10.2943 3.29156Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.1692f2c1251613ff1f06333dccaedb1d.svg";
export { ForwardRef as ReactComponent };